import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeCustomerSupport: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'Customer Support',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Interactive conversational Avatars',
        },
        {
            label: 'Customer training',
        },
        {
            label: 'Knowledge base',
        },
        {
            label: 'How-to guides',
        },
        {
            label: 'Sales enablement',
        },
        {
            label: 'Employee onboarding',
        },
        {
            label: 'Customer onboarding',
        },
        {
            label: 'Product update',
        },
        {
            label: 'Customer comms',
        },
        {
            label: 'AI innovation',
        },
        {
            label: 'Other',
        },
    ],
};
